import Container from "../../components/Container/Container";
import Countdown from "../../components/Countdown/Countdown"
import React from "react"

import styles from './Home.module.scss';

import kamiImg from '../../assets/kamena-6.jpg'
import hristoImg from '../../assets/hristo-3.JPG'
import headingImg from '../../assets/heading-image.jpg';
import headingImg2 from '../../assets/heading-image-2.jpg';

import PersonCard from "../../components/PersonCard/PersonCard";
import Story from "../../components/Story/Story";
import Card from "../../components/Card/Card";
import RSVP from "../../components/RSVP/RSVP";
import Divider from '../../components/Divider/Divider';
import AddressMap from "../../components/AddressMap/AddressMap";
import useScrollToAnchor from "../../hooks/useScrollToAnchor";
import Page from "../../components/Page";
import { SCHEDULE } from "../../config";
import Timeline from "../../components/Timeline/Timeline";
import AddToCalendarButtons from "../../components/AddToCalendarButtons/AddToCalendarButtons";

const STORY_POINTS = [
    {
        title: '2013г.',
        description: 'Запознаваме се на зелено училище в ТУЕС.'
    },
    {
        title: '31 Октомври 2015г.',
        description: 'Официалното начало на нашата връзка.'
    },
    {
        title: '12 Mай 2020г.',
        description: 'Тръгнахме да си търсим таралежче (неуспешно) и си взимаме Кали, нашето френско булдогче.'
    },
    {
        title: '10 Mай 2021г.',
        description: 'Заживяхме официално заедно в новия ни апартамент.'
    },
    {
        title: '26 Октомври 2024г.',
        description: 'Сгодихме се в Япония, в прекрасния парк на Нара, заобиколени от сърнички.'
    }
]

const Home = () => {
    useScrollToAnchor();

    return (
        <Page title="Камена & Христо ♥ Сватба">
            <Container center className={styles.hero}>
                <div className={styles.backgroundImage} />
                <div className={styles.content}>
                    <h1>Камена & Христо</h1>
                    <Countdown className={styles.countdown} />
                </div>
            </Container>

            <Container center>
                <img alt="heading-img" src={headingImg} width={200} />
                <h2>Малко за нас</h2>
                <div className={styles.ourStories}>
                    <PersonCard className={styles.personCard} imageSrc={kamiImg} name="Камена Дачева" description={<span>Като по-малка Ками е много притеснителна и стеснителна, трудно завръзва разговори с нови хора. Повечето време прекарва четейки книга или с тесния си кръг от приятели. С времето, заобиколена от своите близки, приятели и Христо, израства и става тази авантюристична и смела личност, целеустремена да изпълни всичките си мечти.</span>} />
                    <Story storyPoints={STORY_POINTS} className={styles.story} />
                    <PersonCard className={styles.personCard} imageSrc={hristoImg} name="Христо Христов" description={<span>Христо още от малък е бил много социален, лесно завръзващ контакти, обичащ да купонясва и да се забавлява. Голяма част от свободното си време прекарва излизайки с компании и приятели.<br/>Когато се запознаваме контрастът между нас е голям. С решителност и постоянство той успява да пречупи на Ками интровертната личност.</span>} />
                </div>
            </Container>

            <Container center>
                <img alt="heading-img" src={headingImg2} width={200} />
                <h2>За сватбата</h2>

                <div className={styles.weddingInfo}>
                    <div className={styles.infoCol}>
                        <p>06.06.2026г.</p><p>17:00 часа</p>
                    </div>
                    <Divider vertical />
                    <div className={styles.infoCol}>
                        <p>Голф клуб и спа „Св. София“</p>
                        <p>с. Равно поле</p>
                    </div>
                </div>

                <div className={styles.schedule}>
                    <Timeline data={SCHEDULE} horizontal />

                    <AddToCalendarButtons />
                </div>

                <div className={styles.aboutTheWedding}>
                    <AddressMap className={styles.mapContainer} />
                    <Card className={styles.formCard} id="rsvp">
                        <h3>Потвърди присъствието си</h3>
                        <RSVP />
                    </Card>
                </div>
            </Container>
        </Page>
    )
}

export default Home;